<template>
	<div class="margin-left">
		<div class="tips text-theme text-sm">为确保是本人操作，请完成以下验证</div>
		<div class="frpm bg-white">
			<p class="text-df text-333">我们已经发送了验证码到手机：</p>
			<p class="fs32 text-bold phonenum">{{userInfo.miPhone}}</p>
			<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="130px"
				class="demo-ruleForm">
				<el-form-item label="请输入验证码" prop="code">
					<el-input type="text" v-model="ruleForm.code" autocomplete="off" placeholder="请输入验证码"></el-input>
					<p class="get-btn" @click="getcode()">{{ beginning ? time + "s后重新获取" : "获取验证码" }}</p>
				</el-form-item>
				<el-form-item label="设置提现密码" prop="pass">
					<el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="确认提现密码" prop="checkPass">
					<el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" placeholder="请输入">
					</el-input>
				</el-form-item>
				<!-- <el-form-item> -->
					<el-button type="primary" class="text-white btn margin-top" @click.stop="submitForm('ruleForm')">确认设置</el-button>
				<!-- </el-form-item> -->
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			var validateCode = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入验证码'));
				} else {
					callback();
				}
			};
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				beginning: false, // 显示倒计时,@Boolean
				time: 60, // 倒计时60S,@Number
				timer: null, // 计时器,@Function
				ruleForm: {
					code: '', //验证码
					pass:'',//密码
					checkPass:'',//密码
				},
				phone:'',
				rules: {
					code: [{
						validator: validateCode,
						trigger: 'blur'
					}],
					pass: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						validator: validatePass2,
						trigger: 'blur'
					}],
				},//表单验证规则
			};
		},
		computed: {
			userInfo() {
				if (this.$store.getters.userInfo) {
					return this.$store.getters.userInfo;
				} else {
					return JSON.parse(localStorage.getItem('USER_INFO'));
				}
			}
		},
		methods: {
			//确认设置
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.setPricePwd()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			/**
			 * 获取验证码
			 * */
			getcode(){
				let _this = this;
				// 如果有倒计时，return false
				if (this.beginning) return false;
				this.beginning = true; // 显示倒计时
				this.ajax('get', '/api/pc/user/getPhoneCode', {
					phone: this.userInfo.phone,
					stat:2,
				}, res => {
					if (res.status == 200) {
						// 清除倒计时,防抖作用
						clearInterval(_this.timer);
						_this.timer = setInterval(() => {
						  if (_this.time == 1) {
						    //倒计时结束就清楚这个倒计时
						    clearInterval(_this.timer);
						    _this.time = 60; // 倒计时60s
						    _this.beginning = false; // 是否显示倒计时改为false
						    return;
						  }
						  _this.time--;
						}, 1000);
					} else {
						_this.beginning = false; // 是否显示倒计时改为false
					}
				})
			},
			/**
			 * 设置提现密码
			 * */
			setPricePwd(){
				this.ajax('post', '/api/user/setPricePwd', {
					price_pwd:this.ruleForm.pass,
					price_pwd_true:this.ruleForm.checkPass,
					code:1234
				}, res => {
					if (res.status == 200) {
						this.$message(res.msg);
						
					} 
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.tips {
		width: 920px;
		height: 43px;
		background: rgba(9, 130, 123, .1);
		line-height: 43px;
		border-radius: 10px 10px 0px 0px;
	}

	.frpm {
		width: 920px;
		height: 633px;
		padding: 59px 136px 0;
		border-radius: 0px 0px 10px 10px;
	}

	.fs32 {
		font-size: 32px;
	}

	.get-btn {
		cursor: pointer;
		color: #09827B;
		width: 100px;
		height: 54px;
		line-height: 54px;
		background: rgba(230, 230, 230, 0.2);
	}
	
	.phonenum{
		margin-top: 33px;
		margin-bottom: 54px;
	}

	/deep/ .el-input__inner {
		border: 0 !important;
		background: rgba(230, 230, 230, 0.2);
		height: 54px;
	}
	/deep/ .el-form-item__content {
		margin-left: 0 !important;
		display: flex;
		align-items: center;
		background: rgba(230,230,230,0.1);
		border: 1px solid #E6E6E6;
		border-radius: 8px;
	}
	
	.btn{
		width: 383px;
		height: 60px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9,130,123,0.2);
		border-radius: 30px;
		margin-top: 90px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/wallet/setpass.vue